import { useEffect } from "react";
import { Link } from "react-router-dom";
import confetti from "canvas-confetti";
import { CheckCircle2, CalendarPlus, MessageCircle } from "lucide-react";
import { Show } from "@clerk/react";
import { ToothMascot } from "@/components/site/ToothMascot";
import { fmtDate, fmtTime } from "@/lib/api";

const gcal = (b) => {
  const d = b.date.replaceAll("-", "");
  const [h, m] = b.time.split(":").map(Number);
  const end = `${String(h + (m === 30 ? 1 : 0)).padStart(2, "0")}${m === 30 ? "00" : "30"}`;
  const p = new URLSearchParams({
    action: "TEMPLATE", text: `Tooth Buds - ${b.child_name} (${b.service})`,
    dates: `${d}T${b.time.replace(":", "")}00/${d}T${end}00`, ctz: "Asia/Kolkata",
    details: `Booking ref ${b.ref}`, location: b.type === "online" ? "Online video consultation" : "Tooth Buds Dental Clinic, Marve Rd, Malad West, Mumbai",
  });
  return `https://calendar.google.com/calendar/render?${p}`;
};

export const Confirmation = ({ b }) => {
  useEffect(() => { confetti({ particleCount: 140, spread: 80, origin: { y: 0.6 }, colors: ["#0d9488", "#f5b82e", "#ff6b6b", "#38bdf8"] }); }, []);
  const wa = `https://wa.me/919820649411?text=${encodeURIComponent(`Hi, I just booked ${b.ref} for ${b.child_name} on ${b.date} at ${b.time}.`)}`;
  return (
    <div className="text-center" data-testid="booking-confirmation">
      <ToothMascot className="animate-floaty mx-auto w-28" />
      <h2 className="mt-4 text-3xl font-bold sm:text-4xl">Yay! Request received</h2>
      <p className="mt-2 text-slate-600">We've sent the details to <b>{b.email}</b>. The clinic will confirm shortly.</p>
      <div className="mx-auto mt-8 max-w-md rounded-[1.75rem] border-2 border-dashed border-teal-300 bg-[#ebfbfa] p-6 text-left">
        <p className="flex items-center gap-2 text-sm font-bold text-teal-700"><CheckCircle2 className="h-4 w-4" />Booking reference</p>
        <p className="font-display mt-1 text-3xl font-bold tracking-wider text-slate-800" data-testid="booking-reference">{b.ref}</p>
        <div className="mt-4 space-y-1 text-sm text-slate-700">
          <p><b>{b.child_name}</b> · {b.service}</p>
          <p>{fmtDate(b.date)} at {fmtTime(b.time)}</p>
          <p>{b.type === "online" ? "Online video consultation (link will be shared)" : "In-clinic visit, Malad West"}</p>
        </div>
      </div>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <a href={gcal(b)} target="_blank" rel="noreferrer" data-testid="booking-add-calendar"
          className="btn-pop inline-flex items-center gap-2 rounded-full bg-teal-600 px-5 py-3 text-sm font-bold text-white"><CalendarPlus className="h-4 w-4" />Add to calendar</a>
        <a href={wa} target="_blank" rel="noreferrer" data-testid="booking-whatsapp-share"
          className="btn-pop inline-flex items-center gap-2 rounded-full bg-[#25d366] px-5 py-3 text-sm font-bold text-white"><MessageCircle className="h-4 w-4" />Message clinic</a>
        <Show when="signed-in">
          <Link to="/my-appointments" data-testid="booking-view-mine" className="btn-pop rounded-full border-2 border-slate-800 px-5 py-3 text-sm font-bold text-slate-800">My visits</Link>
        </Show>
      </div>
    </div>
  );
};
